import { render, staticRenderFns } from "./MedicalCheckUp.vue?vue&type=template&id=3e69e5f8&"
import script from "./MedicalCheckUp.vue?vue&type=script&lang=js&"
export * from "./MedicalCheckUp.vue?vue&type=script&lang=js&"
import style0 from "./MedicalCheckUp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports